import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconTrainFrontView: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="train-front-view, tram"><path d="M6.75 2.75H17.25L20.25 5.25V17.25H3.75V5.25L6.75 2.75Z" stroke="currentColor" strokeWidth="1.5"/><path d="M7.16016 17L4.66016 22H6.33721L8.6695 17.3354L7.99868 17H7.16016Z" fill="currentColor"/><path d="M15.9987 17L15.3279 17.3354L17.6602 22H19.3372L16.8372 17H15.9987Z" fill="currentColor"/><path d="M4 11.25H20" stroke="currentColor" strokeWidth="1.5"/><circle cx="8" cy="14.25" r="1" fill="currentColor"/><circle cx="16" cy="14.25" r="1" fill="currentColor"/></CentralIconBase>;
};

export default IconTrainFrontView;
